import React from 'react'

const Call = ({
  size = 20,
  color = '#676767',
}: {
  size?: number
  color?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.6633 16.771C18.6633 16.771 17.5047 17.909 17.2207 18.2427C16.7582 18.7363 16.2132 18.9693 15.4988 18.9693C15.4301 18.9693 15.3568 18.9693 15.2881 18.9648C13.9279 18.8779 12.6639 18.3478 11.7159 17.8953C9.12382 16.643 6.84771 14.8652 4.95629 12.612C3.39461 10.7336 2.35044 8.99687 1.65891 7.13217C1.233 5.99415 1.07729 5.1075 1.14598 4.27113C1.19178 3.7364 1.39787 3.29308 1.77798 2.91374L3.33966 1.35526C3.56406 1.14502 3.80221 1.03076 4.03577 1.03076C4.32429 1.03076 4.55786 1.20443 4.70441 1.35069C4.70899 1.35526 4.71357 1.35983 4.71815 1.3644C4.99751 1.62491 5.26313 1.89456 5.54249 2.18249C5.68446 2.32874 5.83101 2.47499 5.97756 2.62581L7.22782 3.87351C7.71327 4.35797 7.71327 4.80586 7.22782 5.29032C7.09501 5.42286 6.96678 5.5554 6.83397 5.68337C6.44927 6.07642 6.75147 5.77483 6.35304 6.13132C6.34388 6.14046 6.33472 6.14503 6.33014 6.15417C5.93629 6.54722 6.00956 6.93113 6.092 7.19164C6.09658 7.20535 6.10116 7.21906 6.10573 7.23277C6.43089 8.01887 6.88886 8.75926 7.58498 9.64134L7.58956 9.64591C8.85355 11.1998 10.1862 12.411 11.6563 13.3387C11.8441 13.4576 12.0364 13.5536 12.2196 13.645C12.3845 13.7272 12.5402 13.8049 12.673 13.8872C12.6913 13.8963 12.7097 13.91 12.728 13.9192C12.8837 13.9969 13.0302 14.0334 13.1814 14.0334C13.5615 14.0334 13.7996 13.7958 13.8775 13.7181L14.7752 12.8222C14.9309 12.6668 15.1782 12.4795 15.4667 12.4795C15.7506 12.4795 15.9842 12.6577 16.1262 12.8131C16.1308 12.8177 16.1308 12.8177 16.1353 12.8222L18.6587 15.3405C19.1305 15.8067 18.6633 16.771 18.6633 16.771Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Call
